import { AxiosServiceClass } from '@/classes/axiosService.class';

// TODO: move these calls to ux web schedules!
class UxRegistrationsApiClass extends AxiosServiceClass {
	includeTimestampHeader = true;
	endpointConfig = [
		{
			key: 'uxr-post-request',
			path: (mode) => `/sys/registrations/V3/ux/${mode}`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-get-request',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/${params.regId}`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-get-eventAttendee',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/${params.eventId}/attendees/${params.attendeeId}/${params.memberId}`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-put-attendee',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/${params.regId}/attendees/${params.attendeeId}`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-put-extend',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/${params.regId}/extend`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-put-complete',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/${params.regId}/complete`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-put-complete-v4',
			path: (params) => `/sys/registrations/V4/ux/${params.mode}/${params.regId}/complete`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-delete-cancel',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/${params.regId}/cancel`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		},
		{
			key: 'uxr-delete-cancelAttendee',
			path: (params) => `/sys/registrations/V3/ux/${params.mode}/0/attendees/${params.attendeeId}`,
			mock: 'context',
			mockPath: () => 'validation-badrequest-get'
		}
	];

	getRequest(mode, regId) {
		return this.get(
			this.endpoint('uxr-get-request', {
				mode: mode,
				regId: regId
			}),
			this.getConfig()
		);
	}

	getEventAttendee(mode, eventId, attendeeId, memberId) {
		return this.get(
			this.endpoint('uxr-get-eventAttendee', {
				mode: mode,
				eventId: eventId,
				attendeeId: attendeeId,
				memberId: memberId
			}),
			this.getConfig()
		);
	}

	postRequest(mode, body) {
		return this.post(
			this.endpoint('uxr-post-request', mode),
			body,
			this.getConfig()
		);
	}

	putAttendee(mode, body, regId, attendeeId) {
		return this.put(
			this.endpoint('uxr-put-attendee', {
				mode: mode,
				regId: regId,
				attendeeId: attendeeId
			}),
			body,
			this.getConfig()
		);
	}

	putExtend(mode, regId) {
		return this.put(
			this.endpoint('uxr-put-extend', {
				mode: mode,
				regId: regId
			}),
			{},
			this.getConfig()
		);
	}

	putComplete(mode, regId, body) {
		return this.put(
			this.endpoint('uxr-put-complete', {
				mode: mode,
				regId: regId
			}),
			body,
			this.getConfig()
		);
	}

	putCompleteWithCaptcha(mode, regId, body, headers = {}) {
		let config = this.getConfig();
		Object.assign(config.headers, headers);

		return this.put(
			this.endpoint('uxr-put-complete-v4', {
				mode: mode,
				regId: regId
			}),
			body,
			config
		);
	}

	deleteCancel(mode, regId) {
		return this.delete(
			this.endpoint('uxr-delete-cancel', {
				mode: mode,
				regId: regId
			}),
			this.getConfig()
		);
	}

	deleteCancelAttendee(mode, attendeeId) {
		return this.delete(
			this.endpoint('uxr-delete-cancelAttendee', {
				mode: mode,
				attendeeId: attendeeId
			}),
			this.getConfig()
		);
	}
}

export const UxRegistrationsApi = new UxRegistrationsApiClass();
